export const getAbsoluteFileUrl = (path: string, provider?: string) => {
  const config = useRuntimeConfig()
  const strapiUrl = config.app.strapiPublicUrl || config.public.strapiPublicUrl
  strapiUrl.endsWith('/') ? strapiUrl.slice(0, -1) : strapiUrl

  if (!path) { return null } else if (path?.startsWith('http') || path?.startsWith('https')) { return path } else if (provider !== 'local') { return path } else { return `${strapiUrl}${path}` }
}
